import { FC } from 'react';

import { Checkbox } from '@components/shared/form-elements/checkbox/Checkbox';
import { IFilterProp, ISetFiltersParam } from '@types';

import classes from './FilterOptions.module.scss';

interface IProps {
  filters: ISetFiltersParam;
  label: string;
  setFilters: (newFilters: IFilterProp[]) => void;
}

const StatusFilters: FC<IProps> = ({ label: labelSection, filters, setFilters }) => {
  const inStock = filters.arrayRes?.find((f) => f.path === 'instock')?.value === '0' || false;
  const preOrder = filters.arrayRes?.find((f) => f.path === 'preorder')?.value === '1' || false;

  const handleFilterChange = (type: string, checked: boolean) => {
    const newFilters = [...(filters.arrayRes || [])];
    const filterIndex = newFilters.findIndex((item) => item.path === type);

    if (type === 'instock') {
      if (!checked && filterIndex === -1) {
        newFilters.push({ path: type, value: '0', rule: 'include' });
      } else if (checked && filterIndex !== -1) {
        newFilters.splice(filterIndex, 1);
      }
    } else {
      if (checked && filterIndex === -1) {
        newFilters.push({ path: type, value: '1', rule: 'include' });
      } else if (!checked && filterIndex !== -1) {
        newFilters.splice(filterIndex, 1);
      }
    }

    setFilters(newFilters);
  };

  return (
    <div className={classes.statusFilterOption}>
      <h6 className={classes.filterTitle}>{labelSection}</h6>
      <div className={classes.filterItems}>
        <Checkbox
          key="status-filter-1"
          checked={!inStock}
          label="В наявності"
          onChange={(_event, checked) => handleFilterChange('instock', checked)}
          name="В наявності"
        />
        <Checkbox
          key="status-filter-0"
          checked={preOrder}
          label="Під замовлення"
          onChange={(_event, checked) => handleFilterChange('preorder', checked)}
          name="Під замовлення"
        />
      </div>
      <hr className={classes.line} />
    </div>
  );
};

export { StatusFilters };
